import { QualitySurveyEditorViewModel } from "src/app/surveys/quality-survey/viewmodels/quality.survey.editor.viewmodel";

export class SubmitQualitySurveyCommand {
  constructor(public survey: QualitySurveyEditorViewModel) { }
}
